import { Component, OnInit } from '@angular/core';
import { messagefromComponent } from '../../class/appinterface';
import { ComponentService } from '../../services/component.service';
import { Utenteservice } from '../../services/utente.service';
import { environment } from '../../../environments/environment';
import { APP_VERSION } from '../../../environments/version';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    Versione = environment.VERSIONE;
    version = APP_VERSION;
    dateCopy: Date;
    infoAziendaFooter;
    infoLicenzaOwner;
    infoAziendaFooterDescLicenza: string;
    infoAziendaFooterCodiceLicenza: string;

    LINK_PRIVACY_POLICY: string = environment.LINK_PRIVACY_POLICY
    LINK_COOCKIE_POLICY: string = environment.LINK_COOCKIE_POLICY
    LINK_ACCESSIBILITA_POLICY: string = environment.LINK_ACCESSIBILITA_POLICY
    constructor(public utenteService: Utenteservice, private componentService: ComponentService) { }

    ngOnInit() {

        this.dateCopy = new Date();
        if (this.utenteService.InfoUtenteConnesso.idtipoutente == 2) {
            this.infoLicenzaOwner = this.utenteService.InfoUtenteConnesso.licenza + ' - ' + this.utenteService.InfoUtenteConnesso.descr_licenza


        } else if (this.utenteService.InfoUtenteConnesso.idtipoutente > 2) {
            let aziendaSelected = this.utenteService.InfoUtenteConnesso['aziendaSelected'];
            console.log('aziendaSelected-->', aziendaSelected);
            //alert(this.utenteService.InfoUtenteConnesso['licenza']);
            this.infoAziendaFooter = this.utenteService.InfoUtenteConnesso['aziende'].find(aziende => {
                return aziende.id == aziendaSelected
            });
            this.infoAziendaFooterCodiceLicenza = this.utenteService.InfoUtenteConnesso['licenza']
            this.infoAziendaFooterDescLicenza = this.utenteService.InfoUtenteConnesso['descr_licenza']
        }

        this.componentService.castMessage.subscribe(
            (message: messagefromComponent) => {

                console.log(message);


                if (message.descrMessage && message.traceMessage)
                    if (message.destComponent.toLowerCase() == 'footer' && message.traceMessage == 'aggiornaIVAFooter') {

                        console.log('spipposss');

                        let aziendaSelected = this.utenteService.InfoUtenteConnesso['aziendaSelected'];

                        this.infoAziendaFooter = this.utenteService.InfoUtenteConnesso['aziende'].find(aziende => {
                            return aziende.id == aziendaSelected
                        });

                    }
            }
        )


        console.log(this.utenteService.InfoUtenteConnesso)
    }
}
